'use strict';

// Constructor
export class AccordionWithColumns {
    constructor() {
        $('.paragraph--type--accordion-with-columns .field--name-field-rows .field__item').each(function(i,accodionitem){
            var $accodionitem = $(accodionitem);
            var expander = "<a href='#expander' class='expander'></a>";
            $accodionitem.find('.field--name-field-column-content > .field__item:first-child .field--name-field-body p:last-child').append(expander);
        })

        $('.paragraph--type--breastpump-hire-table .views-field-title').each(function(i,accodionitem){
            var $accodionitem = $(accodionitem);
            var expander = "<a href='#expander' class='expander'></a>";
            $accodionitem.find('.field-content').append(expander);
        })

        $('.paragraph--type--accordion-with-columns').on('click', '.expander', function(e){
            e.preventDefault();
            $(this).parents('.columns').next('.expanded-content').slideToggle(); //.toggleClass('expanded');
            $(this).toggleClass('expanded');
        })

        $('.paragraph--type--breastpump-hire-table').on('click', '.expander', function(e){
            e.preventDefault();
            $(this).parents('.views-row').find('.views-field-description__value').toggleClass('expanded');
            $(this).toggleClass('expanded');
        })


        $('.view-display-id-local_group_breastpumps_v2 .view-content').wrap('<div class="bp-hire-content-responsive-wrapper"></div>');


    }
}